module.exports = __webpack_public_path__ + "public/images/flags/Turkey.37070d3060221664ccf5c021fbdaaeab.png";